export default __webpack_public_path__ + "static/media/ganzkoerper-reward-funnel-2.b9910810.png";